<template>
  <div class="XLautomobile">
    <div id="container"></div>
    <div class="box">
      <div class="box-text">
        <p>浦创智能</p>
        <!-- <button type="button" class="btn btn-outline-light btn-lg">
          探索更多
        </button> -->
        <h4>引领新一代驾乘体验的智能座舱一体化供应商</h4>
      </div>
      <div class="arrow-up" @click="hanleaboutUs" ref="arrow">
        <span></span>
        <span></span>
      </div>
    </div>
  </div>
</template>

<script>
import * as THREE from "three";
// import Stats from "three/addons/libs/stats.module.js";

import { OrbitControls } from "three/addons/controls/OrbitControls.js";

import { GLTFLoader } from "three/addons/loaders/GLTFLoader.js";
import { RGBELoader } from "three/addons/loaders/RGBELoader.js";
import { DRACOLoader } from "three/addons/loaders/DRACOLoader.js";
export default {
  name: "XLautomobile",
  data() {
    return {
      camera: undefined,
      scene: undefined,
      renderer: undefined,
      controls: undefined,
      stars: undefined,
      clock: undefined,
      points: undefined,
    };
  },
  methods: {
    hanleaboutUs() {
      var anchor = document.getElementById("aboutUs");
      var top = document.getElementById("top");
      console.log(anchor.offsetTop);
      anchor.scrollIntoView();
      top.classList.add("d-block");
      top.classList.remove("d-none");
      top.classList.add("page-top-background");
      top.classList.add("animate__fadeInDown");
      document.getElementsByClassName(
        "dropdown-menu"
      )[0].style.backgroundColor = "#2d323700";
      document.getElementsByClassName(
        "dropdown-menu"
      )[1].style.backgroundColor = "#2d323700";
    },
    init() {
      const container = document.getElementById("container");
      this.clock = new THREE.Clock();

      this.renderer = new THREE.WebGLRenderer({ antialias: true });
      this.renderer.setSize(container.offsetWidth, container.offsetHeight);
      this.renderer.toneMapping = THREE.ACESFilmicToneMapping;
      this.renderer.toneMappingExposure = 0.85;
      container.appendChild(this.renderer.domElement);

      this.camera = new THREE.PerspectiveCamera(
        60,
        container.offsetWidth / container.offsetHeight,
        0.1,
        100
      );
      this.camera.position.set(4.25, 2.2, -2.5);
      this.controls = new OrbitControls(this.camera, container);
      this.controls.enableDamping = true;
      this.controls.maxDistance = 9;
      this.controls.target.set(0, 0.5, 0);
      this.controls.enableZoom = false;
      this.controls.update();

      // this.controls.addEventListener("change", function (event) {
      //   console.log("change");
      //   // 暂停动画
      // });
      // this.controls.addEventListener("start", function (event) {
      //   console.log("start");
      // });
      // this.controls.addEventListener("end", function (event) {
      //   console.log("end");
      //   // 恢复动画
      // });

      this.scene = new THREE.Scene();
      this.scene.background = new THREE.Color(0x101114);
      this.scene.environment = new RGBELoader().load(
        "/style/venice_sunset_1k.hdr"
      );
      this.scene.environment.mapping = THREE.EquirectangularReflectionMapping;
      this.scene.fog = new THREE.Fog(0x0089ff, 10, 15);

      var cloud = this.cloudFun();
      this.stars = cloud;
      this.scene.add(cloud);

      const dracoLoader = new DRACOLoader();
      dracoLoader.setDecoderPath("/style/gltf/");

      const loader = new GLTFLoader();
      loader.setDRACOLoader(dracoLoader);
      this.nebula();
    },

    nebula() {
      const params = {
        count: 12000,
        size: 0.01,
        radius: 5,
        branches: 3,
        spin: 3,
        randomness: 0.69,
        randomPower: 3,
        insideColor: "#0089ff",
        outsideColor: "#0089ff",
      };
      let geometry = null;
      let pointsMaterial = null;
      let positions = null;
      let colors = null;
      geometry = new THREE.BufferGeometry();
      positions = new Float32Array(params.count * 3);
      colors = new Float32Array(params.count * 3);
      const insideColor = new THREE.Color(params.insideColor);
      const outsideColor = new THREE.Color(params.outsideColor);
      for (let i = 0; i < params.count; i++) {
        const i3 = i * 3;
        const radius = Math.random() * params.radius;
        const spinAngle = radius * params.spin;
        const branchAngle =
          ((i % params.branches) / params.branches) * Math.PI * 2;
        const randomX =
          Math.pow(Math.random(), params.randomPower) *
          (Math.random() < 0.5 ? 1 : -1) *
          params.randomness;
        const randomY =
          Math.pow(Math.random(), params.randomPower) *
          (Math.random() < 0.5 ? 1 : -1) *
          params.randomness;
        const randomZ =
          Math.pow(Math.random(), params.randomPower) *
          (Math.random() < 0.5 ? 1 : -1) *
          params.randomness;
        positions[i3] = Math.sin(branchAngle + spinAngle) * radius + randomX;
        positions[i3 + 1] = 0 + randomY;
        positions[i3 + 2] =
          Math.cos(branchAngle + spinAngle) * radius + randomZ;
        const mixedColor = insideColor.clone();
        mixedColor.lerp(outsideColor, radius / params.radius);
        colors[i3] = mixedColor.r;
        colors[i3 + 1] = mixedColor.g;
        colors[i3 + 2] = mixedColor.b;
      }
      geometry.setAttribute("color", new THREE.BufferAttribute(colors, 3));
      geometry.setAttribute(
        "position",
        new THREE.BufferAttribute(positions, 3)
      );
      pointsMaterial = new THREE.PointsMaterial({
        color: 0xffffff,
        size: params.size,
        depthWrite: true,
        vertexColors: true,
        sizeAttenuation: true,
        blending: THREE.AdditiveBlending,
      });
      this.points = new THREE.Points(geometry, pointsMaterial);
      this.scene.add(this.points);
    },
    cloudFun() {
      const positions = [];
      this.geometry = new THREE.BufferGeometry();
      for (var i = 0; i < 10000; i++) {
        var vertex = new THREE.Vector3();
        vertex.x = Math.random() * 200 - 100;
        vertex.y = Math.random() * 200 - 100;
        vertex.z = Math.random() * 200 - 100;
        positions.push(vertex.x, vertex.y, vertex.z);
      }
      this.geometry.setAttribute(
        "position",
        new THREE.Float32BufferAttribute(positions, 3)
      );
      // 星星资源图片
      const texture = new THREE.TextureLoader().load("/style/spot.png");
      var starsMaterial = new THREE.PointsMaterial({
        alphaMap: texture,
        size: 0.4,
        transparent: true,
        opacity: 1,
        alphaTest: false,
        //true：且该几何体的colors属性有值，则该粒子会舍弃第一个属性--color，而应用该几何体的colors属性的颜色
        // vertexColors: true,
        color: 0x0089ff,
        depthWrite: false,
        blending: THREE.AdditiveBlending,
        sizeAttenuation: true,
      });
      let stars = new THREE.Points(this.geometry, starsMaterial);
      return stars;
    },
    createLightMateria() {
      var canvasDom = document.createElement("canvas");
      canvasDom.width = 16;
      canvasDom.height = 16;
      var ctx = canvasDom.getContext("2d");
      //根据参数确定两个圆的坐标，绘制放射性渐变的方法，一个圆在里面，一个圆在外面
      var gradient = ctx.createRadialGradient(
        canvasDom.width / 2,
        canvasDom.height / 2,
        0,
        canvasDom.width / 2,
        canvasDom.height / 2,
        canvasDom.width / 2
      );
      gradient.addColorStop(0, "rgba(255,255,255,1)");
      gradient.addColorStop(0.005, "rgba(139,69,19,1)");
      gradient.addColorStop(0.4, "rgba(139,69,19,1)");
      gradient.addColorStop(1, "rgba(0,0,0,1)");
      //设置颜色为渐变
      ctx.fillStyle = gradient;
      //绘图
      ctx.fillRect(0, 0, canvasDom.width, canvasDom.height);
      //贴图使用
      let texture = new THREE.Texture(canvasDom);
      texture.needsUpdate = true; //使用贴图时进行更新
      return texture;
    },
    animate() {
      requestAnimationFrame(this.animate);
      this.controls.update();

      this.stars.rotation.y += 0.0006;
      this.points.rotation.y += 0.0006;

      this.renderer.render(this.scene, this.camera);
    },
  },
  mounted() {
    this.init();
    this.animate();
    let that = this;
    var lastScrollTop = 0;
    window.addEventListener("scroll", function () {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop > lastScrollTop) {
        if (scrollTop > 280 && that.$refs["arrow"]) {
          that.$refs["arrow"].classList.add("d-none");
          that.$refs["arrow"].classList.remove("d-block");
        }
      } else {
        if (scrollTop < 280 && that.$refs["arrow"]) {
          that.$refs["arrow"].classList.add("d-block");
          that.$refs["arrow"].classList.remove("d-none");
        }
      }
      lastScrollTop = scrollTop;
    });
  },
};
</script>

<style lang="less" scoped>
.XLautomobile {
  #container {
    height: 100vh;
    width: 100vw;
  }
  // .box {
  //   height: 100vh;
  //   width: 100vw;
  // }
  .box-text {
    position: absolute;
    top: 35%;
    text-align: center;
    width: 100%;
    p {
      color: #fff;
      font-size: 4rem;
      font-weight: 500;
      letter-spacing: 5px;
    }
    h4 {
      margin-top: 0.2rem;
      font-size: 1.6rem;
      color: #fff;
      font-weight: 400;
      letter-spacing: 5px;
      line-height: 2rem;
    }
  }
  .arrow-up {
    position: absolute;
    left: 50%;
    bottom: 5%;
    width: 10px;
    height: 10px;
    color: white;
    z-index: 200;
    cursor: pointer;
    span {
      position: absolute;
      width: 20px;
      height: 20px;
      top: 10px;
      transform: rotate(45deg);
      border-top: 1px solid white;
      border-left: 1px solid white;
      margin-left: -10px;
      opacity: 0;
      animation: up 2s infinite;
      animation: up 2s infinite;
    }
    span:nth-of-type(1) {
      -webkit-animation-delay: 0.15s;
      animation-delay: 0.15s;
    }
    span:nth-of-type(2) {
      top: 20px;
    }
  }
}
@-webkit-keyframes up {
  0% {
    opacity: 0;
    -webkit-transform: translate(0, 0) -webkit-rotate(45deg);
  }
  50% {
    opacity: 1;
    -webkit-transform: translate(0, -20px) -webkit-rotate(45deg);
  }
  100% {
    opacity: 0;
  }
}
@keyframes up {
  0% {
    opacity: 0;
    transform: translate(0, 0) rotate(45deg);
  }
  50% {
    opacity: 1;
    transform: translate(0, -20px) rotate(45deg);
  }
  100% {
    opacity: 0;
  }
}
</style>
